<template>
  <div>
    <!-- 邮件 -->
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <!-- 开始时间 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 搜索 -->
        <div class="item">
          <el-button type="primary" @click="search">{{ $t("message.search") }}</el-button>
        </div>
        <div class="add">
          <!-- 群发信息 -->
          <router-link to="/emailMessaging" target="_blank" v-if="isAuth(402)">
            <el-button type="success">
              {{ $t("message.massMessaging") }}
            </el-button>
          </router-link>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 收件人 -->
          <el-table-column align="center" :label="$t('message.recipients')" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.type == '全部客户'">
                {{ scope.row.type }}</span>
              <el-button type="text" v-else @click="EmailPushPushUserList(scope.row)">
                {{ scope.row.type }}
              </el-button>
            </template>
          </el-table-column>
          <!-- 邮件标题 -->
          <el-table-column align="center" :label="$t('message.mailTitle')" prop="title">
          </el-table-column>
          <!-- 邮件内容 -->
          <el-table-column align="center" :label="$t('message.mailContent')" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="look(scope.row)">{{ $t('message.lookContent') }}</el-button>
              <!-- <div v-html="scope.row.content"></div> -->
            </template>
          </el-table-column>
          <!-- 添加日期 -->
          <el-table-column align="center" :label="$t('message.addDate')" width="200" prop="created_at">
          </el-table-column>
          <!-- 发送时间 -->
          <el-table-column align="center" :label="$t('message.sendTime')" width="200" prop="send_at">
          </el-table-column>
          <!-- 发送状态 -->
          <el-table-column align="center" :label="$t('message.sendingStatus')" width="200" prop="status">
            <template slot-scope="scope">
              {{ scope.row.status_name }}
              <div class="num">
                <div class="item">
                  成功:{{ scope.row.success_count }}
                </div>
                <div class="item">
                  失败：{{ scope.row.fail_count }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 开封数量 -->
          <el-table-column align="center" :label="$t('message.sendingStatus')" width="200" prop="status">
            <template slot-scope="scope">

              <div class="num">
                <div class="item">
                  已开封:{{ scope.row.opened_count }}
                </div>
                <div class="item">
                  未开封：{{ scope.row.is_dispatched }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 人员列表 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px" center>
      <el-table :data="userData" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
        <!-- 客户ID -->
        <el-table-column prop="id" label="ID" align="center" width="100">
        </el-table-column>
        <!--客户名称-->
        <el-table-column prop="realname" label="客户名称" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 查看内容 -->
    <preview ref="preview" />
  </div>
</template>
<script>
import preview from "./preview";
export default {
  components: {
    preview,
  },
  data() {
    return {
      activeName: 1,
      dialogVisible: false,
      datas: {
        range: "",
        dateStart: "",
        dateEnd: "",
        pageSize: 10,
        page: 1
      },
      total: 0,
      tableData: [],
      item: {},
      userData: [],
    };
  },
  created() {
    // 同组织各工种账号列表
    this.$api.getAuthWorkGroupAdminSameLevel().then(res => {
      this.y = res.data.y
    })
    this.EmailPushPushList();
  },
  methods: {
    EmailPushPushList() {
      this.$api.noticeApi.EmailPushPushList(this.datas).then((res) => {
        this.tableData = res.data.data
        this.total = res.data.total
      });
    },
    //查看
    look(item) {
      this.$refs.preview.content = item.content
      this.$refs.preview.dialogVisible = true;
    },
    //部分用户列表
    EmailPushPushUserList(item) {
      this.$api.noticeApi.EmailPushPushUserList({ msg_id: item.id }).then((res) => {
        this.userData = res.data
        this.dialogVisible = true
      });
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.EmailPushPushList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.EmailPushPushList()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.EmailPushPushList()
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;
  flex-wrap: wrap;

  .item {
    width: 240px;
  }

  .add {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.table {
  margin: 20px 0;
}

.content {
  max-height: 100px;
  overflow-y: auto;
}

/deep/.ql-editor {
  height: 300px !important;
}

.num {
  display: flex;
  width: 100%;

  .item {
    flex: 1;
    justify-content: center;
    align-items: center;
    color: #85ce61;

    &:nth-last-child(1) {
      color: red;
    }
  }
}
</style>